var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-action-bar",class:_vm.active ? 'ibx-action-bar--active' : ''},[_c('div',{staticClass:"ibx-action-bar__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }